import { useCallback } from "react";
import { useCsrfToken } from "@/hooks/use-csrf-token";

/**
 * Returns a callback that POSTs to a Travily endpoint to mint a fresh
 * Stripe AccountSession client_secret. Used as the `fetchRefreshedClientSecret`
 * prop on `PayoutsFrame` — Stripe's runtime fires this when the initial
 * server-rendered token approaches expiry.
 */
export function useStripeConnectSessionRefresher(refreshUrl: string): () => Promise<string> {
  const csrfToken = useCsrfToken();

  return useCallback(async () => {
    const response = await fetch(refreshUrl, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: "{}",
    });
    if (!response.ok) {
      throw new Error(`Failed to refresh Stripe AccountSession (HTTP ${response.status})`);
    }
    const { client_secret: clientSecret } = await response.json();
    return clientSecret;
  }, [csrfToken, refreshUrl]);
}
